module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0173.jpg?v=3a303606";